import { settingConfigT } from "../../utils/settingConfig";
import { IComponent } from "../../utils/type/dynamic-rendering.interfaces";
import { saveActiveSectionT } from "../../utils/type/typesTempSectionSides";
import { activeOption, listActiveSettingT, stateT } from "../reducers/Settings";

export const getListSection = ({ ...state }) => {
  return state['Configuration']['sections']['listSection'];
}
export const getInitializationThreekitData = ({ ...state }) => {
  return state['Configuration']['initializationThreekitData'];
}
export const getOpenSectionIdInSides = ({ ...state }) => {
  return state['Configuration']['interface']['openSectionIdInSides'];
}
export const getKeySectionActive = ({ ...state }) => {
  return state['Configuration']['sections']['activeSection'];
}

export const getIsLoad = ({ ...state }) => {
  return state['Configuration']['interface']['isLoad'];
}
export const getIsLoadStateData = ({ ...state }) => {
  return state['Configuration']['interface']['isLoadStateData'];
}

export const getListViews = ({ ...state }) => {
  return state['Configuration']['view']['listViews'];
}
export const getKeyViewActive = ({ ...state }) => {
  return state['Configuration']['view']['activeView'];
}


export const getVisiblePrice = ({ ...state }) => {
  return state['Configuration']['modalInfo']['visiblePrice'];
}
export const getVisibleSaveConfig = ({ ...state }) => {
  return state['Configuration']['modalInfo']['visibleSaveConfig'];
}

export const getCustomerInfoSetting = ({ ...state }) => {
  let settings: any = state['Configuration']['paramsConfiguration']['settingUI'];
  let activeSection = settings.filter((setting: any) => setting['key'] === 'CustomerInfo');

  return activeSection[0];

}
export const getActiveSection = ({ ...state }) => {
  let settings: any = state['Configuration']['paramsConfiguration']['settingUI'];
  let activeSectionKey = getKeySectionActive(state);
  if (activeSectionKey === 'CustomerInfo') activeSectionKey = 'Product';
  let activeSection = settings.filter((setting: any) => setting['key'] === activeSectionKey);

  return activeSection[0] && activeSection[0]['setting'];
}
export const getSettingConfig = ({ ...state }) => {
  let setting: any = state['Configuration']['paramsConfiguration']['settingUI'];

  return setting;
}

export type valueOption = {
  selectValue: string,
  isError: boolean
}
export type valueMultipleOption = {
  selectValue: string[] | null,
  isError: boolean
}
export type getValueOptionT = {
  idOptions: string,
  parentKeySection?: any
}
export const getValueOption = ({ idOptions, parentKeySection }: getValueOptionT) => (state: any): valueOption => {

  let activeSettingUI: listActiveSettingT[] = state['Configuration']['paramsConfiguration']['activeSettingUI'];


  let activeSection: string = state['Configuration']['sections']['activeSection'];

  let activeSectionOptions: listActiveSettingT = activeSettingUI.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]

  if (!!parentKeySection) {

    let activeSideOption: valueOption = getValueOption({ idOptions: 'orientationSide' })(state)
    let parentSectionOptionsName = `OptionsSideGroup_${activeSideOption['selectValue']}`
    let activeSide: activeOption = activeSectionOptions['listOptions'].filter((option: activeOption) => option['optionId'] === parentSectionOptionsName)[0]

    if (!activeSide['value']) return { selectValue: '', isError: activeSide['isError'] }

    let activeSectionSide = activeSide['value'][parentKeySection]
    if (!activeSectionSide) return { selectValue: '', isError: false }

    let activeOption = activeSectionSide[idOptions]

    if (!activeOption) return { selectValue: '', isError: false }

    return { selectValue: activeOption['value'], isError: activeOption['isError'] };

  }

  let activeOption: activeOption = activeSectionOptions['listOptions'].filter((option: activeOption) => option['optionId'] === idOptions)[0]

  if (!activeOption) return { selectValue: '', isError: false }

  return { selectValue: activeOption['value'], isError: activeOption['isError'] };


}
export const getValueMultipleOption = (idOptions: string) => (state: any): valueMultipleOption => {
  let activeSettingUI: listActiveSettingT[] = state['Configuration']['paramsConfiguration']['activeSettingUI'];


  let activeSection: string = state['Configuration']['sections']['activeSection'];

  let activeSectionOptions: listActiveSettingT = activeSettingUI.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]


  let activeOption: activeOption = activeSectionOptions['listOptions'].filter((option: activeOption) => option['optionId'] === idOptions)[0]

  return { selectValue: activeOption['value'], isError: activeOption['isError'] };
}



type getValueSideSectionOptionT = {
  selectValue: saveActiveSectionT[] | [],
  isError: boolean
}
export const getValueSideSectionOption = (idOptions: string) => (state: any): getValueSideSectionOptionT => {

  let activeSettingUI: listActiveSettingT[] = state['Configuration']['paramsConfiguration']['activeSettingUI'];
  let activeSideOption: valueOption = getValueOption({ idOptions: 'orientationSide' })(state)

  let activeSection: string = state['Configuration']['sections']['activeSection'];


  let activeSectionOptions: listActiveSettingT = activeSettingUI.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]

  let activeOption: activeOption = activeSectionOptions['listOptions'].filter((option: activeOption) => option['optionId'] === idOptions)[0]

  if (!activeOption) return { selectValue: [], isError: false }
  if (!activeOption['value']) return { selectValue: [], isError: false }

  if (!activeSideOption['selectValue']) return { selectValue: [], isError: false }
  if (!activeOption['value'][activeSideOption['selectValue']]) return { selectValue: [], isError: false }

  return { selectValue: activeOption['value'][activeSideOption['selectValue']], isError: false };
}
export const getSideSection = (state: any): IComponent[] => {

  let allSections: IComponent[] = state['Configuration']['paramsConfiguration']['settingForSides'];
  let activeSideOption: getValueSideSectionOptionT = getValueSideSectionOption('orientationSideView')(state)

  let allSectionTemp: IComponent[] = [];
  if (!!activeSideOption['selectValue'] && activeSideOption['selectValue'].length > 0) {
    activeSideOption['selectValue'].forEach((idSection: saveActiveSectionT) => {
      let section: IComponent = allSections.filter((sections: IComponent) => sections['data']['id'] === idSection['idSection'])[0];
      let tempSection: IComponent = JSON.parse(JSON.stringify(section))
      tempSection['data'] = {
        ...tempSection['data'],
        keySection: idSection['keySection']
      }

      allSectionTemp.push(tempSection)
    })
  }
  return allSectionTemp;
}

export const getNotificationModal = (state: any) => {
  let notificationModal = null;
  let stateC: stateT = state['Configuration'];
  let notificationsModal = stateC['modalInfo']['notificationModal'];

  if (notificationsModal && notificationsModal.length > 0) {
    notificationModal = notificationsModal[0];
  }
  return notificationModal;
}
export const getCustomerInfoValue = (state: any) => {
  let stateC: stateT = state['Configuration'];
  let notificationsModal = stateC['paramsConfiguration']['activeSettingUI']

  let activeSection: string = 'CustomerInfo';

  let activeSectionOptions: listActiveSettingT = notificationsModal.filter((listActiveSetting: listActiveSettingT) => listActiveSetting['sectionId'] === activeSection)[0]


  let customerInfoValue: activeOption[] = activeSectionOptions['listOptions'].filter((setting: activeOption) => setting['sectionId'] === "CustomerInfo")
  let isCheckCustomerInfo = true;

  customerInfoValue.forEach((setting: activeOption) => {
    if (!!setting['isError']) {
      isCheckCustomerInfo = false;
    }
    if (!setting['value']) {
      isCheckCustomerInfo = false;
    }
  })

  return isCheckCustomerInfo;
}
export const getActiveSideForSectionSides = (state: any) => {
  let stateC: stateT = state['Configuration'];
  let activeSide = getValueOption({ idOptions: 'orientationSide' })(state)
  let SettingUI: settingConfigT[] = stateC['paramsConfiguration']['settingUI'];

  let sectionSide: settingConfigT = SettingUI.filter((section: any) => section['key'] === 'Sides')[0]
  let orientationProperty: any = []

  const setItemActiveSetting = (settingUI: IComponent) => {
    let orientationProperty: any = {}

    if (!!settingUI['data']['embeddedView'] && settingUI['data']['embeddedView'].length > 0) {
      settingUI['data']['embeddedView'].forEach((settingUI: IComponent) => {
        if (settingUI['data']['id'] === 'orientationSide') {
          orientationProperty = settingUI['data']['values']

        }
        setItemActiveSetting(settingUI)
      })
    } else {
      if (settingUI['data']['id'] === 'orientationSide') {
        orientationProperty = settingUI['data']['values']

      }
    }


    return orientationProperty
  }

  sectionSide['setting'].forEach((settingUI: IComponent) => {
    orientationProperty = setItemActiveSetting(settingUI)
  })

  // debugger

  let activeSideTest: any = orientationProperty.filter((item: any) => item['id'] === activeSide['selectValue'])[0]


  return activeSideTest;
}
export const getAdditionalSectionsSides = (state: any) => {
  let stateC: stateT = state['Configuration'];
  let settingForSides = stateC['paramsConfiguration']['settingForSides']

  let allSectionForSides = settingForSides.map((section: IComponent) => {
    return {
      label: section['data']['label'],
      value: section['data']['id'],
    }
  })

  return allSectionForSides;
}

